module.exports = __webpack_public_path__ + "img/top-vague4-mobile.cf8e1fb7.jpg";